import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, ValidationErrors, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatOptionModule } from '@angular/material/core';
import { MatFormField, MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { RequestAccessService } from 'src/app/core/services/request-access.service';

@Component({
  selector: 'app-request-access',
  templateUrl: './request-access.component.html',
  styleUrls: ['./request-access.component.scss'],
})
export class RequestAccessComponent implements OnInit {
  requestForm: FormGroup;
  loggedInuser: any;
  module: string[] = ['EBU', 'Distribution', 'Components', 'Power_Systems', 'Overall', 'Omni'];

  // Mapping of modules → submodules
  subModuleMapping: { [key: string]: string[] } = {
    EBU: ['Engines', 'Parts'],
    Distribution: ['CSSNA', 'International', 'DBU-Overall'],
    Components: ['CES', 'CDBS', 'CSE', 'CEC'],
    Power_Systems: ['Engines', 'Power Gen', 'Parts'],
    Accelera: [''],
    Overall: ['Overall view'],
    Omni: ['Omni Dashboard']
  };

  // Active submodule list (based on selection)
  subModule: string[] = [];
  constructor(
    private fb: FormBuilder,
    private keycloakService: KeycloakService,
    private requestAccessService: RequestAccessService,
    private router: Router,
  ) {
    this.requestForm = this.fb.group({
      userEmail: ['', [Validators.required, Validators.email]],
      reason: ['', [Validators.required]],
      selectedModule: [[], [Validators.required]],
      selectedSubModule: [[], [Validators.required]],
    });
  }
  ngOnInit(): void {
    this.keycloakService.loadUserProfile().then(profile => {
      this.loggedInuser = profile;

      this.requestForm.get('userEmail')?.setValue(profile?.email);
    });


      //  Listen to module selection changes
    this.requestForm.get('selectedModule')?.valueChanges.subscribe((modules: string[]) => {
      // Collect all submodules for selected modules
      this.subModule = modules.flatMap(m => this.subModuleMapping[m] || []);

      // Reset submodule selection if not valid
      this.requestForm.get('selectedSubModule')?.setValue([]);
    });
  }
  get userEmailControl() {
    return this.requestForm.get('userEmail');
  }

  get ccControl(): AbstractControl | null {
    return this.requestForm.get('cc');
  }

  emailValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (!value) return null;

    const emails = value
      .split(',')
      .map(email => email.trim())
      .filter(email => email.length > 0);

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const invalidEmails = emails.filter(email => !emailRegex.test(email));
    return invalidEmails.length > 0 ? { emailFormat: true } : null;
  }

  submitRequest() {
    if (this.requestForm.invalid) {
      this.requestForm.markAllAsTouched();
      return;
    }

    // payload values 
    const formValue = this.requestForm?.value;

    const userEmail = this.loggedInuser?.email;
    const reason = formValue?.reason;
    const module = formValue?.selectedModule;
    const subModule = formValue?.selectedSubModule;

    this.requestAccessService.requestAccess(userEmail, reason, module, subModule).subscribe(
      (res) => {
        console.log('Email sent successfully!', res);
          alert('Access request email sent successfully.');
          this.keycloakService.logout(window.location.origin); // redirects to login
      });    
  }
}

